import { JoeIp, Schema } from "../../../../../@types";
import { enums } from "../../../../../../../shim/jsbridge";
import Name from "../../../../../../search/schema/components/Name";

const { analyzer: { URLANALYZER = 1 } = {} } = enums || {};

export const ip: Schema<JoeIp> = {
  fields: [
    {
      name: "k_ip",
      displayTitle: "IP",
      sortable: true,
      component: d => (
        <Name
          data={{
            file_name: d.k_ip,
            int_submission_analyzer: URLANALYZER
          }}
        />
      ),
      style: { width: "10%" }
    },
    {
      name: "k_country",
      displayTitle: "Country",
      sortable: true,
      component: d => <>{d.k_private === "true" ? "--" : d.k_country}</>,
      style: { width: "15%" }
    },
    {
      name: "k_private",
      displayTitle: "Private",
      sortable: true,
      component: d => <>{d.k_private}</>,
      style: { width: "8%" }
    },
    {
      name: "k_asnnbr",
      displayTitle: "ASN",
      sortable: true,
      component: d => <>{d.k_private === "true" ? "--" : d.k_asnnbr}</>,
      style: { width: "10%" }
    },
    {
      name: "k_asnname",
      displayTitle: "ASN Name",
      sortable: true,
      component: d => <>{d.k_private === "true" ? "-" : d.k_asnname}</>,
      style: { width: "15%" }
    },
    {
      name: "k_malicious",
      displayTitle: "Malicious",
      sortable: true,
      component: d => <>{d.k_private === "true" ? "-" : d.k_malicious}</>,
      style: { width: "10%" }
    }
  ]
};
